import React from 'react';
import { Clock } from 'lucide-react';
import { ScheduleTable } from '../../components/ScheduleTable';
export function FamilyClassTimes() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1063">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1064">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1065">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1066">
            <Clock className="w-3.5 h-3.5" data-id="element-1067" />
            Class Times
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1068">
            Class Times & What to Expect
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1069">
            Family classes run on the same mat with multiple instructors so
            parents and kids can train side by side. Expect a warm-up,
            skill-focused drills, partner work, and a positive close — about an
            hour, every time.
          </p>
        </div>

        <div className="mb-12" data-id="element-1070">
          <ScheduleTable data-id="element-1071" />
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-1072">
          {[{
          step: '1',
          title: 'Arrive Together',
          desc: 'No uniform needed for your trial — comfortable athletic clothing is perfect.'
        }, {
          step: '2',
          title: 'Train Side by Side',
          desc: 'Parents and kids work on the same mat. Coaches adapt drills to each person.'
        }, {
          step: '3',
          title: 'Walk Out Energized',
          desc: 'Everyone leaves having moved, learned, and shared something positive together.'
        }].map((s, i) => <div key={i} className="bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3" data-id="element-1073">
              <div className="w-10 h-10 rounded-full bg-storm-red text-white font-bold flex items-center justify-center" data-id="element-1074">
                {s.step}
              </div>
              <h3 className="text-lg text-ink" data-id="element-1075">{s.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-1076">{s.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}